import { UserTranslation } from "./userTranslation.js";
import { User } from "./user.js";
import { IDictionary } from "./dictionary.js";
import { LabelData } from "./labelData.js";
const defaultUserName = "hansmuster";
const labelPath = "data/labels.json";
const userPath = "data/users/";
let labels: IDictionary<LabelData> = {};

window.onload = async function () {
  const urlParams = new URLSearchParams(window.location.search);
  let userParam = urlParams.get("user") || urlParams.get("u");

  if (!userParam) {
    const basePath = window.location.pathname.split("/").slice(0, 2).join("/");
    window.location.href = `${window.location.origin}${basePath}?user=${defaultUserName}`;
    return;
  }

  labels = (await loadData(labelPath)).translations.reduce(
    (acc: IDictionary<LabelData>, t: any) => {
      acc[t.lang] = new LabelData(t.data);
      return acc;
    },
    {},
  );
  let user = new User(
    (await loadData(userPath + userParam.toLowerCase() + ".json")) || {},
  );
  console.log("Loading user:", user.name);

  SetPageTitle(user.name);
  SetUserColor(user);
  CreateLanguagesButtons(user);
  changeLanguage(user, Object.keys(user.translations)[0]);
  fadeBlackOverlayAway();
};

async function loadData(filePath: string): Promise<any> {
  try {
    const response = await fetch(filePath);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const textData = await response.text();
    return JSON.parse(textData);
  } catch (error) {
    console.error("Error loading data:", error);
  }
}

function setActiveLangButton(languageTag: string): void {
  document
    .querySelectorAll(".button-container > .language > button")
    .forEach(function (btn) {
      btn.classList.remove("active");
    });
  var activeBtn = document.querySelector(
    ".button-container > .language > ." + languageTag,
  ) as HTMLElement;
  if (activeBtn) activeBtn.classList.add("active");
}

function SetUserColor(user: User): void {
  if (user.accentColor)
    document.documentElement.style.setProperty("--accent", user.accentColor);
  if (user.darkColor)
    document.documentElement.style.setProperty("--dark", user.darkColor);
  if (user.lightColor)
    document.documentElement.style.setProperty("--light", user.lightColor);
  const degree = `${45 + (Math.random() * 30 - 15)}deg`;
  document.documentElement.style.setProperty("--bg-degree", degree);
  document.documentElement.style.setProperty("--bg-degree-back", degree);
}

function CreateLanguagesButtons(user: User): void {
  const container = document.querySelector(
    ".button-container > .language",
  ) as HTMLElement;
  container.innerHTML = "";

  let userLanguages: string[] = Object.keys(user.translations);

  if (userLanguages.length <= 1) {
    container.style.display = "none";
    return;
  }
  // Remove style display none if previously set
  container.style.display = "";

  userLanguages.forEach((languageTag) => {
    const button = document.createElement("button") as HTMLButtonElement;
    button.className = languageTag;
    button.textContent = languageTag.toUpperCase();
    button.addEventListener("click", function () {
      changeLanguage(user, languageTag);
    });
    container.appendChild(button);
  });
}

function changeLanguage(user: User, languageTag: string): void {
  updateUserContent(user, languageTag);
  updateLabels(languageTag);
  setActiveLangButton(languageTag);
  requestAnimationFrame(matchJobWidthToName);
}

function setTextContent(selector: string, text: string): void {
  const element = document.querySelector(selector);
  if (element) {
    element.textContent = text;
  }
}

function updateUserContent(user: User, languageTag: string): void {
  const userLangData: UserTranslation =
    user.translations[languageTag] || user.translations["en"] || null;
  if (!userLangData) {
    console.warn("No user data for language:", languageTag);
    return;
  }
  setTextContent(".logo", user.name);
  setTextContent(".name", user.name);
  setTextContent(".job", userLangData.title);

  const infoEl = document.querySelector(".info") as HTMLElement;
  infoEl.innerHTML = "";
  const propertyClass: string = "property";
  const valueClass: string = "value";
  for (const propertyLabel in userLangData.properties) {
    const labelSpan = document.createElement("span");
    labelSpan.className = propertyClass + " " + propertyLabel;
    labelSpan.textContent = propertyLabel + ":";

    const valueSpan = document.createElement("span");
    valueSpan.className = valueClass + " " + propertyLabel;
    valueSpan.textContent = userLangData.properties[propertyLabel];

    infoEl.appendChild(labelSpan);
    infoEl.appendChild(valueSpan);
  }

  // setTextContent(".value.email a", userLangData.email);
  // (document.querySelector(".value.email a") as HTMLAnchorElement).href =
  //   "mailto:" + userLangData.email;
  //
  // setTextContent(".value.phone a", userLangData.phone);
  // (document.querySelector(".value.phone a") as HTMLAnchorElement).href =
  //   "tel:" + userLangData.phone;
  //
  // setTextContent(".value.address", userLangData.address);

  //setTextContent('.value.company', userLangData.company);
}

function updateLabels(languagetag: string): void {
  // const labelsForLang: LabelData = labels[languagetag] || labels["en"];
  // setTextContent(".property.email", labelsForLang.email + ":");
  // setTextContent(".property.phone", labelsForLang.phone + ":");
  // setTextContent(".property.address", labelsForLang.address + ":");
  //setTextContent('.property.company', labelsForLang.company + ':');
}

function matchJobWidthToName() {
  const nameEl = document.querySelector(".name") as HTMLElement;
  const jobEl = document.querySelector(".job") as HTMLElement;
  if (!nameEl || !jobEl) return;
  jobEl.style.letterSpacing = "";
  const maxSpacing = 20;
  const minSpacing = 2;
  const correctionMargin = 4; // to avoid line break due to rounding errors

  let bestSpacing = minSpacing;

  for (let spacing = minSpacing; spacing <= maxSpacing; spacing += 0.1) {
    jobEl.style.letterSpacing = spacing + "px";
    jobEl.style.textIndent = -spacing + "px";
    if (jobEl.offsetWidth + correctionMargin > nameEl.offsetWidth) {
      break;
    }
    bestSpacing = spacing;
  }
  jobEl.style.letterSpacing = bestSpacing + "px";
  jobEl.style.textIndent = -bestSpacing + "px";
}

function SetPageTitle(name: string) {
  document.title = name + " - Business Card";
}
function fadeBlackOverlayAway() {
  const overlay = document.getElementById("page-black-overlay");
  if (overlay) {
    overlay.classList.add("fade-out");
    setTimeout(() => {
      overlay.style.display = "none";
    }, 300);
  }
}
